import { API_ENDPOINTS } from "../constants/endpoints";
import axiosInstance from "../utils/axios";

export const verifyEmail = (token) => {
  return axiosInstance.post(
    API_ENDPOINTS.VERIFY_EMAIL.replace(":token", token)
  );
};
export const resetPassword = (dataBody) => {
  console.log('API_ENDPOINTS.resetPassword: ', API_ENDPOINTS.resetPassword);
  return axiosInstance.post(API_ENDPOINTS.resetPassword, dataBody);
};
export const accountDeletion = (dataBody) => {
  return axiosInstance.post(API_ENDPOINTS.SEND_ACCOUNT_DELETION, dataBody);
};